'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { fromMoment, toMoment } from 'UIComponents/core/SimpleDate';
import { getDateRangePresetForString, PRESET_TYPES } from '../lib/AdsSimpleDateRange';
import I18n from 'I18n';
import { Networks, EntityStatusMap } from './Constants';
const VALID_STATUSES = Object.keys(EntityStatusMap);

const legacyDecodeTimeRange = timeRange => {
  if (timeRange[0] === '{') {
    const {
      startDate,
      endDate
    } = JSON.parse(timeRange);
    return getDateRangePresetForString(PRESET_TYPES.CUSTOM, fromMoment(I18n.moment(startDate)), fromMoment(I18n.moment(endDate)));
  }

  return getDateRangePresetForString(timeRange);
};

const decodeTimeRange = (timeRange, startDate, endDate) => {
  if (startDate && endDate) {
    return getDateRangePresetForString(PRESET_TYPES.CUSTOM, fromMoment(I18n.moment(parseInt(startDate, 10))), fromMoment(I18n.moment(parseInt(endDate, 10))));
  }

  if (timeRange && Object.keys(PRESET_TYPES).includes(timeRange)) {
    return getDateRangePresetForString(timeRange);
  }

  return null;
};

const getQueryFromFilters = globalFilters => Object.assign({
  attributionView: globalFilters.attributionView,
  statuses: globalFilters.statuses.join(),
  adAccounts: null
}, Object.keys(Networks).reduce((byNetwork, network) => {
  byNetwork[network] = globalFilters.adAccounts.filter(adAccount => adAccount.network === network).map(adAccount => adAccount.accountId).join();
  return byNetwork;
}, {}), {}, globalFilters.timeRange.type === PRESET_TYPES.CUSTOM ? {
  startDate: toMoment(globalFilters.timeRange.startDate).valueOf(),
  endDate: toMoment(globalFilters.timeRange.endDate).valueOf(),
  timeRange: null
} : {
  startDate: null,
  endDate: null,
  timeRange: globalFilters.timeRange.type
});

const unsafeGetFiltersFromQuery = queryString => {
  const queryObject = ImmutableMap(queryString.split('&').map(querySection => decodeURIComponent(querySection).split('='))).toJS();
  const {
    attributionView,
    endDate,
    startDate,
    statuses,
    timeRange,
    usersAndTeams
  } = queryObject;
  const decodedAdAccounts = Object.keys(Networks).reduce((adAccounts, network) => {
    const accountIdStr = queryObject[network];

    if (!accountIdStr) {
      return adAccounts;
    }

    const accountIds = accountIdStr.split(',');
    return adAccounts.concat(accountIds.map(accountId => ({
      accountId,
      network
    })));
  }, ImmutableSet());
  const decodedStatuses = statuses ? statuses.split(',').filter(status => VALID_STATUSES.indexOf(status) > -1) : [];
  return {
    attributionView,
    statuses: decodedStatuses.length > 0 ? decodedStatuses : null,
    adAccounts: decodedAdAccounts.isEmpty() ? null : decodedAdAccounts,
    timeRange: decodeTimeRange(timeRange, startDate, endDate),
    usersAndTeams
  };
};

const legacyUnsafeGetFiltersFromQuery = queryString => {
  const queryObject = ImmutableMap(queryString.split('&').map(querySection => decodeURIComponent(querySection).split('='))).toJS();
  const {
    attributionView,
    statuses,
    adAccounts,
    timeRange
  } = queryObject;
  const decodedAdAccounts = adAccounts && JSON.parse(adAccounts).map(([network, accountId]) => ({
    network,
    accountId
  }));
  const decodedStatuses = statuses ? JSON.parse(statuses) : [];
  return {
    attributionView,
    statuses: decodedStatuses.length > 0 ? decodedStatuses : null,
    adAccounts: decodedAdAccounts && !decodedAdAccounts.some(account => !account) ? ImmutableSet(decodedAdAccounts) : null,
    timeRange: timeRange && legacyDecodeTimeRange(timeRange)
  };
};

export const getFiltersFromQuery = queryString => {
  try {
    const parseMethod = queryString.indexOf('adAccounts') > -1 ? legacyUnsafeGetFiltersFromQuery : unsafeGetFiltersFromQuery;
    return parseMethod(queryString.substr(1));
  } catch (e) {
    return {};
  }
};
export const getQueryStringFromFilters = globalFilters => {
  const filtersQuery = getQueryFromFilters(globalFilters);
  const existingQuery = ImmutableMap(window.location.search.substring(1).split('&').map(keyVal => decodeURIComponent(keyVal).split('='))).toJS();
  const newQuery = Object.assign({}, existingQuery, {}, filtersQuery);
  return `?${Object.keys(newQuery).filter(key => !!newQuery[key]).map(key => `${key}=${newQuery[key]}`).join('&')}`;
};